<template>
  <span>{{text}}</span>
</template>

<script>
export default {
  name: "ElapsedTime",
  props: {
    startAt: {
      type: String,
      required: true,
    },
    prependLabel: {
      type: String,
      default: ''
    },
  },
  data(){
    return {
      interval: null,
      text: '-'
    }
  },
  mounted(){
    this.setTimer()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    setTimer(){
      const vm = this
      vm.interval = setInterval(() => {
        const diff = vm.$moment().diff(vm.$moment(vm.startAt))
        const duration = vm.$moment.duration(diff)
        let humanized

        if(duration.hours() === 0 && duration.minutes() === 0) {
          vm.text = `${vm.prependLabel} unos segundos`
          return
        }

        let hours = duration.hours()
        const hoursLabel = `hora${hours > 1 ? 's' : ''}`

        let minutes = duration.minutes()
        const minutesLabel = `minuto${minutes > 1 ? 's' : ''}`

        let hoursForHumans = hours > 0 ? `${hours} ${hoursLabel}` : ''
        let minutesForHumans =  minutes > 0 ? `${minutes} ${minutesLabel}` : ''

        if(hoursForHumans && minutesForHumans){
          humanized =  `${hoursForHumans} y ${minutesForHumans}`
        }else{
          humanized = hoursForHumans ? `${hoursForHumans}` : `${minutesForHumans}`
        }

        vm.text = `${vm.prependLabel} ${humanized}`

      }, 1000)
    }
  }
}
</script>

<style scoped>

</style>
